<template>
  <v-dialog v-model="dialog" persistent width="600">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9>
          <v-icon>add</v-icon> Crear feriado 
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex md6>
                <v-text-field
                  label="Descripción"
                  v-model="form.descripcion"
                  :rules="$validate(['required'])"
                  required
                  maxlength="1000"
                ></v-text-field>
              </v-flex>
              <v-flex md6>
                <v-text-field
                  label="Fecha"
                  type="date"
                  v-model="form.fecha"
                  :rules="$validate(['required'])"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex md12>
                <v-autocomplete
                  :items="tipos_feriados"
                  item-value="id"
                  item-text="descripcion"
                  v-model="form.id_tipo"
                  label="Tipo"
                  maxlength="100"
                  :rules="$validate(['required'])"
                  required
                />
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex md12>
                <v-autocomplete
                  v-if="form.id_tipo == 2 || form.id_tipo == 3"
                  :items="departamentos"
                  item-value="id"
                  item-text="valor"
                  v-model="form.id_departamento"
                  label="Departamento"
                  maxlength="100"
                  :rules="$validate(['required'])"
                  required
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <small class="error--text text-required"
            >* Los campos son obligatorios</small
          >
          <v-spacer></v-spacer>
          <v-btn @click.native="close()">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn color="primary" type="submit" :loading="loading">
            <v-icon dark>check</v-icon> {{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      tipos_feriados: [
        { id: 1, descripcion: "Nacional" },
        { id: 2, descripcion: "Departamental" },
        ///WC
       { id: 3, descripcion: "Internacional" }
      ],
      departamentos: [],
      dialog: false,
      form: {},
      valid: false,
      loading: false
    };
  },
  watch: {
    // Observar cambios en el tipo de feriado seleccionado
    'form.id_tipo': function(newVal, oldVal) {
      if (newVal === 2 || newVal === 3) {
        this.obtenerDepartamentos();
      } else {
        // Limpiar departamentos si no es tipo 2 o 3
        this.departamentos = [];
        this.form.id_departamento = null;
      }
    }
  },
  async mounted() {
    this.$bus.$on("openDialogCrearActualizarFeriado", item => {
      this.form = item;
      if (this.form.id_tipo === 2 || this.form.id_tipo === 3) {
        this.obtenerDepartamentos();
      }
      this.dialog = true;
    });
  },
  methods: {
    close() {
      (this.form = {}), (this.loading = false);
      this.valid = false;
      this.$bus.$emit("closeDialog");
      this.dialog = false;
    },
    
    async obtenerDepartamentos() {
      try {
        let queryType = "";
        
        if (this.form.id_tipo === 2) {
          queryType = "departamentos";
        } else if (this.form.id_tipo === 3) {
          queryType = "departamentos_ext";
        } else {
          this.departamentos = [];
          return;
        }

        let res = await this.$service.graphql({
          query: `
            query {
              params(tipo:"${queryType}") {
                rows {
                  id
                  valor
                }
              }
            }
          `
        });
        
        this.departamentos = res.params.rows;
      } catch (error) {
        console.log(error);
        this.$alert("Error al cargar departamentos", "", "Error");
      }
    },




    async save() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          let tipoNacional = 0;
          
          // Mapear tipos correctamente
          if (this.form.id_tipo === 1) {
            tipoNacional = 1;
          } else if (this.form.id_tipo === 2) {
            tipoNacional = 0;
          } else if (this.form.id_tipo === 3) {
            tipoNacional = 2;
          }
      

		  let user = this.$storage.get('user') 
          let feriado = {
            fecha: this.form.fecha,
            descripcion: this.form.descripcion,
            nacional: tipoNacional,
            id_estado: 1,
            id_parametro: this.form.id_departamento ?this.form.id_departamento:null 
          };
          let respuesta = await this.$service.graphql({
            query: `
                    query{
                      runQuery(consulta:"select general.fn_registra_feriado('${feriado.fecha}','${feriado.descripcion}',${feriado.id_parametro},${feriado.nacional},${parseInt(user.id)})"){
                        respuesta
                      }
                    }
                  `
          });
		  respuesta=respuesta.runQuery.respuesta[0].fn_registra_feriado.split("|")
		  if(respuesta[0]=="1"){
			this.$alert(respuesta[1],"","Aviso")
			this.close()
		  }
		  else{
			this.$alert(respuesta[1],"","Aviso")	
		  }
        } catch (error) {
          console.log(error);
        }
        this.loading = false;
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/feriado/dialogs/CrearActualizarFeriado.vue